module.exports = __webpack_public_path__ + "static/img/preview-03.e59bbe99.webp";